/* CRO kosmetik (sprog-neutral, 28-10-2026): køb-knappen skal se aktiv ud når en indstilling mangler, og føre kunden til valget. */
(function () {
  var SEL = '.sticky-atc-panel__add-to-cart-btn, form[action*="/cart/add"] button[type="submit"]';
  function picker() { return document.querySelector('variant-picker') || document.querySelector('.option-selector'); }
  /* Navn på den første indstilling der endnu ikke er valgt (fx "storlek", "färg"), ellers null */
  function missingName() {
    var p = picker(); if (!p) return null;
    var sels = p.querySelectorAll('.option-selector');
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i], type = s.getAttribute('data-selector-type'), chosen;
      if (type === 'listed') chosen = !!s.querySelector('input:checked');
      else {
        var sel = s.querySelector('select');
        if (sel) chosen = !!sel.value;
        else { var lb = s.querySelector('[role="listbox"]'), act = lb && lb.getAttribute('aria-activedescendant'), opt = act && document.getElementById(act); chosen = !!(opt && opt.getAttribute('data-value')); }
      }
      if (!chosen) {
        var l = s.querySelector('legend, .label'), t = l && l.firstChild ? l.firstChild.textContent : (l ? l.textContent : '');
        t = (t || '').replace(/[:\s]+$/, '').trim();
        return t ? t.toLowerCase() : '*';
      }
    }
    return null;
  }
  var busy = false;
  function mark() {
    if (busy) return; busy = true;
    var miss = missingName();
    [].forEach.call(document.querySelectorAll(SEL), function (b) {
      /* Sprog-neutral: knappen er deaktiveret fordi en indstilling (størrelse/farve) mangler. Teksten ("Velg størrelse" osv.) kommer fra vejb-vaelg-tekst.liquid. */
      var needs = (b.disabled || b.getAttribute('aria-disabled') === 'true') && !!miss;
      b.classList.toggle('cro-needs-choice', needs);
    });
    busy = false;
  }
  document.addEventListener('click', function (e) {
    var hit = [].filter.call(document.querySelectorAll('.cro-needs-choice'), function (b) {
      var r = b.getBoundingClientRect();
      return r.width && e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    })[0];
    if (!hit) return;
    var p = picker(); if (!p) return;
    p.scrollIntoView({ behavior: 'smooth', block: 'center' });
    p.classList.remove('cro-pulse'); void p.offsetWidth; p.classList.add('cro-pulse');
  }, true);
  function init() {
    mark();
    document.addEventListener('change', function () { setTimeout(mark, 50); setTimeout(mark, 400); }, true);
    new MutationObserver(function () { mark(); }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'checked', 'aria-activedescendant', 'aria-selected'], characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
